import { SET_BUSQUEDA } from '../types';

export const setBusqueda = (busqueda) => ({
    type: SET_BUSQUEDA,
    payload: busqueda
});
